(function () {
  var LINKS = [
    { label: "Scrapyard", href: "/collections/scrapyards" },
    { label: "Jackets", href: "/collections/scrapyards#sy-jackets" },
    { label: "Hoods", href: "/collections/scrapyards#sy-hoods" },
    { label: "Sweats", href: "/collections/scrapyards#sy-sweats" },
    { label: "Tees", href: "/collections/scrapyards#sy-tees" },
    { label: "Diego set", href: "/products/diego-bundle" }
  ];

  function inject(modal) {
    if (!modal || modal.querySelector("[data-rof-search-trending]")) return;

    var box = document.createElement("div");
    box.className = "header__search-popular";
    box.setAttribute("data-rof-search-trending", "true");

    var label = document.createElement("span");
    label.className = "header-label";
    label.textContent = "Trending";
    box.appendChild(label);

    LINKS.forEach(function (item) {
      var a = document.createElement("a");
      a.className = "header__search-popular-link";
      a.href = item.href;
      a.textContent = item.label;
      box.appendChild(a);
    });

    var collection = modal.querySelector(".header__search-collection");
    if (collection && collection.parentNode) {
      collection.parentNode.insertBefore(box, collection);
    } else {
      var form = modal.querySelector("form, predictive-search") || modal;
      form.appendChild(box);
    }
  }

  function boot() {
    document.querySelectorAll(".header__search-modal").forEach(inject);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
